namespace Ir.Components.Filters.FilterVM {

    interface IFilterViewModel {
        filter: Filter;
        filters: KnockoutObservableArray<Filter>

        preserveDrillDownFilterSettings: DevExpress.ui.dxSwitch.Properties;
        element: JQuery<HTMLElement>;
        showPreserveDrillingDownWidget: KnockoutObservable<boolean>;

        allowRemove: KnockoutComputed<boolean>;
        allowSettings: KnockoutComputed<boolean>;
        showFilterBar: KnockoutComputed<boolean>;
        filterComponent: KnockoutComputed<string>;
        isNotOrDifferent: KnockoutComputed<boolean>;
        filterBarSelectedWidth: KnockoutComputed<string>;
        filterLabelText: KnockoutComputed<string>;
        filterTextTitle: KnockoutComputed<string>;
        compactFilterType: KnockoutComputed<string>;

        filterSettingsButton: DevExpress.ui.dxButton.Properties;
        removeFilterButton: DevExpress.ui.dxButton.Properties;

        showComponent: Function;
    }

    export function getViewModel(this: IFilterViewModel, params) {
        this.element = params.element;
        this.filters = params.filters;
        this.filter = params.filter;

        this.showPreserveDrillingDownWidget = ko.observable(this.filter.scope() === ContainerScopeEnum.Report);
        let self = this;

        this.filterTextTitle = ko.computed(function () {
            //Used to convert the html to text
            let span = document.createElement("span");
            span.innerHTML = self.filter.startDisplayCondition();
            return span.textContent;
        });
        this.filterLabelText = ko.computed(function () {
            return `${self.filter.filterName()}${(self.filter.isMetric() ? "" : self.filter.conditionTypeIcon)}`;
        });
        this.allowRemove = ko.computed(function () {
            let allowEdit = loggedUser.permissions.workbooks() || (workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.ViewOnly && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted);
            if (self.filter.modifier() === FilterModifiersEnum.UserFilter) {
                allowEdit = false;
            }
            else if (self.filter.modifier() === FilterModifiersEnum.CreatedByViewer) {
                allowEdit = true;
            }

            return workbook.workbookConfig.workbookHelper.showHideFilterActions() && allowEdit;
        }.bind(this));

        this.allowSettings = ko.computed(function () {
            let allowEdit = loggedUser.permissions.workbooks() || (workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.ViewOnly && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted);
            if (self.filter.modifier() === FilterModifiersEnum.UserFilter) {
                allowEdit = false;
            }
            else if (self.filter.modifier() === FilterModifiersEnum.CreatedByViewer) {
                allowEdit = true;
            }

            return workbook.workbookConfig.workbookHelper.showHideFilterActions() && allowEdit;
        }.bind(this));

        this.showFilterBar = ko.computed(function () {
            return self.filter.filterEditorType() !== FilterEditorTypeEnum.Switch;
        });

        this.isNotOrDifferent = ko.computed(function () {
            return self.filter.conditionType() === FilterConditionTypeEnum.NotIn || self.filter.conditionType() === FilterConditionTypeEnum.Different ||
                self.filter.conditionType() == FilterConditionTypeEnum.NotBetween;
        });

        this.filterComponent = ko.computed(function () {
            let editorType = self.filter.filterEditorType();
            if (editorType === FilterEditorTypeEnum.AutoComplete || editorType === FilterEditorTypeEnum.ValuesCombo) {
                editorType = FilterEditorTypeEnum.MultiSelect;
            }

            let index = Object.values(FilterEditorTypeEnum).indexOf(editorType)
            let name = Object.keys(FilterEditorTypeEnum)[index];

            if (self.filter.isMetric()) {
                name = "Metric";
            }

            return name.charAt(0).toLowerCase() + name.slice(1) + "-filter";
        });
        
        this.filterBarSelectedWidth = ko.computed(function () {
            if ((self.filter.filterEditorType() === FilterEditorTypeEnum.MultiSelect || self.filter.filterEditorType() === FilterEditorTypeEnum.AutoComplete) &&
                self.filter.multipleCondition() && self.filter.dataSourceLength() > 0) {
                return `${(self.filter.multipleCondition().length / self.filter.dataSourceLength() * 100)}%`;
            }

            return "0%";
        });

        this.compactFilterType = ko.computed(function () {
            return `compact-filter-type-${FilterEditorTypeEnum[self.filter.filterEditorType()]}`;
        });

        this.showComponent = function (model, evt) {
            evt.stopPropagation();

            if (self.filter.readOnly() || self.filter.filterEditorType() === FilterEditorTypeEnum.Switch) {
                return;
            }

            let show = function () {
                let popover = $('div.filter', self.element).data("dxPopover");
                if (!popover) {
                    popover = $('div.filter', self.element).dxPopover({
                        target: $('.filterEditor', self.element),
                        showEvent: 'dxclick',
                        position: 'bottom',
                        hideOnOutsideClick: true,
                        width: self.filter.isMetric() ? 380 :
                            self.filter.filterEditorType() === FilterEditorTypeEnum.DateRange ? 280 :
                                self.filter.filterEditorType() === FilterEditorTypeEnum.Date ? 200 : 235,
                        onShown: function () {
                            if (self.filter.filterEditorType() === FilterEditorTypeEnum.AutoComplete || self.filter.filterEditorType() === FilterEditorTypeEnum.MultiSelect ||
                                self.filter.filterEditorType() === FilterEditorTypeEnum.ValuesCombo) {
                                let searchBox = $('.dx-datagrid-search-panel.dx-textbox.dx-texteditor.dx-searchbox input', ".dx-popup-content");
                                if (searchBox) {
                                    searchBox.focus();
                                }
                            }
                        }
                    }).dxPopover("instance");
                }

                popover.toggle();
            };

            if (self.filter.updateDataSource) {
                self.filter.updateDataSource(function () {
                    show();
                });
            }
            else {
                show();
            }
        };

        this.preserveDrillDownFilterSettings = {
            value: this.filter.preserveDrillDownFromWidget(),
            onValueChanged: function (data) {
                if (data.previousValue !== data.value) {
                    self.filter.preserveDrillDownFromWidget(data.value);
                    self.filter.publish();
                }
            }
        };

        this.filterSettingsButton = {
            icon: "preferences",
            width: 20,
            height: 20,
            onClick(e) {
                e.event.stopPropagation();

                let popoverData = $('div.filter', self.element).data("dxPopover");
                if (popoverData) {
                    popoverData.hide();
                }

                if (self.filter.readOnly()) {
                    return;
                }

                let popover = $('.popover-filter-settings', self.element).data("dxPopover");
                if (!popover) {
                    popover = $('.popover-filter-settings', self.element).dxPopover({
                        showEvent: 'dxclick',
                        position: 'bottom',
                        width: 300,
                    }).dxPopover("instance");
                }

                popover.option("target", e.element);
                popover.show();
            }
        };
        this.removeFilterButton = {
            icon: "remove",
            width: 20,
            height: 20,
            elementAttr: {
                class: "removeFilterButton"
            },
            onClick(e) {
                e.event.stopPropagation();

                let popover = $('div.filter', self.element).data("dxPopover");
                if (popover) {
                    popover.hide();
                }

                if (self.filter.readOnly()) {
                    return;
                }

                if (self.filter.isComparisonFilter()) {
                    self.filters.remove(self.filter);
                    return;
                }

                self.filter.remove();
            }
        };
    }
}